/* off-canvas sidebar toggle */
$(function () {
    $('[data-toggle=offcanvas]').click(function () {
        var $trigger = $(this),
            $target;

        if ($trigger.data('target') !== 'undefined') {
            $target = $($trigger.data('target'));
        } else {
            $target = $($trigger.attr('href'));
        }

        $target.toggleClass('active');
        $target.find('.sidebar-text').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });
});
